/**
 * Numeric Range.
 *
 * @private
 */
export class DoubleRange {
    /**
     * The start value.
     *
     * @private
     * @returns {number} - The start value.
     */
    get start() {
        return this.mStart;
    }
    /**
     * The end value.
     *
     * @private
     * @returns {number} - The end value.
     */
    get end() {
        return this.mEnd;
    }
    /**
     * The delta between the start and end values.
     *
     * @private
     * @returns {number} - The delta value.
     */
    get delta() {
        return (this.mEnd - this.mStart);
    }
    constructor(start, end) {
        if (start < end) {
            this.mStart = start;
            this.mEnd = end;
        }
        else {
            this.mStart = end;
            this.mEnd = start;
        }
    }
}
